import { CONFIG, api } from './_barrel.js';


        async function downloadTripReport(tripId, tier, token) {
            const resp = await fetch(`${CONFIG.apiBase}/api/v1/trips/${tripId}/report?tier=${tier}`, {
                headers: { 'Authorization': `Bearer ${token}` },
            });
            if (!resp.ok) throw new Error(`Download failed: HTTP ${resp.status}`);
            const blob = await resp.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url; a.download = `veil_trip_${tier}_${tripId.slice(0,8)}.pdf`;
            document.body.appendChild(a); a.click(); a.remove();
            URL.revokeObjectURL(url);
        }

export { downloadTripReport };
